import { Tile } from '@/models/tiles';
import { ReactNode } from 'react';

export enum RouletteType {
  Default = 'default',
  Infinity = 'infinity',
}
export interface RouletteProps<T> {
  prizes: Tile[];
  prizeIndex: number;
  customCard: (data: Tile, index: number) => React.ReactNode;
  start: boolean;
  spinningTime: number;
  onPrizeDefined?: VoidFunction;
  className?: string;
  firstItem?: number;
  hideCenterPin?: boolean;
  type?: RouletteType;
  isPaperColor?: boolean;
  isTransparent?: boolean;
  centerSpin?: ReactNode;
}
